<template>
  <div class="PersonMain">
    <Content :style="{margin: '0 0 0 10px', padding: '14px', minHeight: layout.minHeight, background: '#eee'}">
      <Row>
        <Col span="20">
          <Form ref="user_information" :model="user_information" :rules="ruleValidate" :label-width="90">
            <FormItem label="用户名" prop="username">
              <Input v-model="user_information.username" :disabled="true" placeholder="请输入您的用户名"></Input>
            </FormItem>
            <FormItem label="邮箱地址" prop="email">
              <Input v-model="user_information.email" :disabled="true" placeholder="请输入您的邮箱地址"></Input>
            </FormItem>
            <FormItem label="验证状态" prop="email">
              <p v-if="user_information.email_verify_status" class="text-success">
                <span class="text-success">已验证通过</span>
              <p v-else>
                未验证通过 <span class="text-error">(请您尽快完成邮箱认证，否则将会造成邮箱所有人重置密码的风险)</span>
              </p>
            </FormItem>
            <transition name="fade">
              <FormItem v-if="status.email_changed | !user_information.email_verify_status" label="邮箱验证码"
                        prop="username">
                <Row>
                  <Col span="10">
                    <Input v-model="user_information.email_code" placeholder="若需要更改或首次验证邮箱地址，请输入您的邮箱验证码"></Input>
                  </Col>
                  <Col span="5" offset="1">
                    <Button v-if="reset_email_code_second <= 0" class="send_email_code" @click="sendEmailCode()"
                            :loading="send_email_loading" type="info">发送验证码
                    </Button>
                    <Button v-else class="send_email_code" :loading="send_email_loading" @click="sendEmailCode()"
                            type="primary">
                      {{reset_email_code_second}}秒后重试
                    </Button>
                  </Col>
                </Row>
              </FormItem>
            </transition>
            <FormItem label="性别" prop="gender">
              <RadioGroup v-model="user_information.gender">
                <Radio label="MAN">男</Radio>
                <Radio label="WOMEN">女</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="登录密码" prop="password">
              <Input v-model="user_information.password" placeholder="若需更改登录密码，请在此输入"></Input>
            </FormItem>
            <transition name="fade">
              <FormItem label="密码确认" v-if="status.password_changed" prop="confirm_password">
                <Input v-model="user_information.confirm_password" placeholder="请再次输入您即将修改的登录密码"></Input>
              </FormItem>
            </transition>
            <FormItem>
              <Button type="primary" @click="Submit()">提交更改</Button>
              <Button @click="Reset()" style="margin-left: 8px">取消更改</Button>
            </FormItem>
          </Form>
        </Col>
      </Row>
    </Content>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "PersonMain",
    data(){
      return {
        reset_email_code_second: 0,
        send_email_loading: false,
        layout: {
          minHeight: '700px',
        },
        status: {
          email_changed: false,
          password_changed: false,
        },
        record_user_information: {},
        user_information: {
          username: '',
          email: '',
          email_code: '',
          email_verify_status: true,
          gender: '',
          last_login_at: '',
          created_at: '',
          password: '',
          confirm_password: '',
        },
        ruleValidate: {
          username: [
            {required: true, message: '用户名不能为空', trigger: 'blur'}
          ],
          email: [
            {required: true, message: '邮箱地址不能为空', trigger: 'blur'},
            {type: 'email', message: '不合法的邮箱地址', trigger: 'blur'}
          ],
          email_code: [
            {required: true, message: '请输入邮箱验证码', trigger: 'blur'}
          ],
          gender: [],
          password: [
            {
              type: 'regexp',
              pattern: /[0-9a-zA-Z]/,
              min: 6,
              max: 18,
              message: '请输入[a-z][A-Z][0-9]范围内长度6-18的密码',
              trigger: 'change'
            }
          ],
          confirm_password: [
            {
              required: false,
              type: 'regexp',
              pattern: /[0-9a-zA-Z]/,
              min: 6,
              max: 18,
              message: '请输入[a-z][A-Z][0-9]范围内长度6-18的密码',
              trigger: 'change'
            },
          ],
          date: [
            {required: true, type: 'date', message: 'Please select the date', trigger: 'change'}
          ],
          time: [
            {required: true, type: 'string', message: 'Please select time', trigger: 'change'}
          ],
          desc: [
            {required: true, message: 'Please enter a personal introduction', trigger: 'blur'},
            {type: 'string', min: 20, message: 'Introduce no less than 20 words', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      resizeHeight(){
        let main_content_height = window.innerHeight;
        this.layout.minHeight = (main_content_height - 35 - 120) + 'px';
      },
      Submit(){
        this.$fetch.user.user_change_profile(this.user_information).then((data)=>{
          this.$Notice.success({
            title: '修改成功',
          });
          this.GetUserInfo();
        })
      },
      Reset(){
        this.$set(this, "user_information", _.cloneDeep(this.record_user_information));
      },
      sendEmailCode(){
        this.$refs.user_information.validateField('email', (valid)=>{
          if(valid === ''){
            this.$fetch.user.send_email_code({
              email: this.user_information.email,
            }).then((data)=>{
              this.reset_email_code_second = data.resend_time;
              this.$Notice.success({
                title: '发送成功',
              });
              this.countDown();
            }).catch((err)=>{
              //重置倒计时
              this.reset_email_code_second = err.data.resend_time;
              this.countDown();
            })
          }
        });
      },
      countDown(){
        let that = this;
        let reset_interval = setInterval(function(){
          if(that.reset_email_code_second > 0){
            that.reset_email_code_second = that.reset_email_code_second - 1;
          }else{
            that.send_email_loading = false;
            clearInterval(reset_interval);
          }
        }, 1000);
      },
      GetUserInfo(){
        this.$fetch.user.user_info().then(data=>{
          this.user_information = data;
          this.record_user_information = _.cloneDeep(data);
        }).catch(err=>{
        })
      }
    },
    computed: {
      ...mapGetters([
        'user',
      ]),
    },
    watch: {
      "status.password_changed": function(){
        if(this.status.password_changed){
          this.ruleValidate['confirm_password'][0]['required'] = true;
        }else{
          this.ruleValidate['confirm_password'][0]['required'] = false;
        }
      },
      "user_information.password": function(){
        this.status.password_changed = this.user_information.password !== this.record_user_information.password;
      },
      "user_information.email": function(){
        this.status.email_changed = this.user_information.email !== this.record_user_information.email;
      }
    },
    mounted(){
      let that = this;
      this.resizeHeight();
      $(window).resize(function(){
        that.resizeHeight();
      });
    },
    created(){
      this.GetUserInfo();
    }
  }
</script>

<style scoped lang="less">
  .PersonMain {
    form {
      background: #fff;
      padding: 50px;
    }

  }
</style>
